import { useContext } from 'react';
import { GenericSnackBarContext } from '../components/context/GenericSnakBarContextProvider';

const useToast = () => {
  const { SuccessToast, ErrorToast, WarningToast } = useContext(
    GenericSnackBarContext
  );
  return { SuccessToast, ErrorToast, WarningToast };
};

export default useToast;
